import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import { PIFlowLeftNavBar } from '../../ReusableComp/NavBarLeft';
import { Col, Container, Row, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getRejectedEventsList, getEventDetails, getPiRejSubject, getRejSubDetails } from '../../../Redux/actions/actions';
import { useNavigate, useLocation } from "react-router";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { base_url } from '../../../utilities';
import { formatDate } from '../../ReusableComp/dateFormat';
import Loader from '../../ReusableComp/Loader';
import PopUpModal from "../../ReusableComp/PopUpModal";


function RejectedSubjects() {
    const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState('');
  let [loading_flag, setloading_flag] = useState(false);
  const [asc,setAsC]=useState(false);
    const [desc,setDesc]=useState(false);
    const [loading, setLoading] = useState(false);

  const rejectedEventsList = useSelector((state) => state.piRejSubj);
  const rejSubjDetls = useSelector((state) => state.rejSubjDetls);
  const studydetails = useSelector((state) => state.studyInfo);
  const location = useLocation();
  
    useEffect(() => {
      if(location.state !== null && rejectedEventsList !== null){
        
        handleRespond(location.state?.data);
        navigate({ state: null });
      }
     
      setloading_flag(true);
        if(!localStorage.getItem("login_user_name")){
            navigate("/");
        }
      //  if(studydetails){ dispatch(getPiRejSubject({
      //       pi_id: localStorage.getItem("pi_id"),
      //       study_id: studydetails.study_id
      //   }))}
        disableBackButton();
       
        setTimeout(() => {
          setloading_flag(false);
        }, 1000);
    }, [dispatch, location.state, navigate,localStorage.study_id, rejSubjDetls !== null, rejectedEventsList !== null]);

    useEffect(() => {
      if (rejSubjDetls) {
        setFilteredData(rejSubjDetls)
      }
    },[rejSubjDetls])

    function disableBackButton() {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', function(event) {
          window.history.pushState(null, null, window.location.pathname);
        });
      }
      const handleStudyChange = () => {
      
      }
      const [sendData, setSendData] = useState("")
      const [open1, setOpen1] = useState(false)

      const alreadyAttended = ()=>{
        setOpen1(false)
        window.location.reload()
          // alert("The event has already been attended to!")
          
      }
    const handleRespond = (data) => {
      if(!(rejectedEventsList?.find(item => (item.subject_id === data.subject_id)))){
        
        // window.location.reload()
        // alert("The event has already been attended to!")
        setOpen1(true)
        return;
      }
      setSendData(data)
      setLoading(true)

      axios
      .post(base_url + 
        "principal-investigator/rejected_subject_details",{
          "subject_id": data.subject_id
      })
      .then((res) => {
        res.data.data.forEach((obj) => {
          const dateOfBirth = new Date(obj.date_of_birth);
          const now = new Date();
          const age = now.getFullYear() - dateOfBirth.getFullYear();
          obj.age = age
        })
      let rejSubjDetls = res.data.data[0]
        navigate('/rejectedsubjedit',{ state:{rejSubjDetls} })       
      })
      .catch((error) => {
        window.isExpired = true;
      });
  }
    
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        setFilteredData(rejectedEventsList)
    }, [rejectedEventsList])
    

    const handleSearchData = (event) => {
      const searchText = event.target.value.toLowerCase();
      setSearchText(searchText);
      const filteredData = rejectedEventsList?.filter((item) => {
          return (
              (item.subject_code && item.subject_code.toLowerCase().includes(searchText.toLowerCase()) )
              ||
              (item.phone_number && (item.phone_number).toString().includes(searchText) )
              
            );
      });
      if(searchText === ""){
        setFilteredData(rejectedEventsList)
      }
      else{
        setFilteredData(filteredData)
      }
      

  }

 

  const handleAscending = () => {
    setAsC(true);
    setDesc(false);
  
    const sortedData = [...filteredData];  
    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;
      return subjectCodeA.localeCompare(subjectCodeB);
    });
    setFilteredData(sortedData);
  };
  
  const handleDescending = () => {
    setDesc(true);
    setAsC(false);
  
    const sortedData = [...filteredData];
  
    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;
      return subjectCodeB.localeCompare(subjectCodeA);
    });
  
    setFilteredData(sortedData);
  };

  const spanStyles = {
    fontSize: '14px',
    fontWeight: 600,
    marginTop: window.innerWidth > 768 ? '0' : '0', // Apply marginTop only on smaller screens
    paddingLeft: window.innerWidth > 768 ? '75px' : '15px', // Apply paddingLeft only on larger screens
  };
  const handleClosePopup = () => {

  }

  return (
    <div>
            <NavigationBar  title={'Subject Clarifications'} handleFilteredData={handleStudyChange}/>
            {/* <PIFlowLeftNavBar /> */}
            <div className='main_body ' >
            <PopUpModal
                handleClose={handleClosePopup}
                open={open1}
                title={"Success!"}
                msg={"Subject has already been attended to!"}
                close={"Close"}
                actionbtn={"Done"}
                onConfirm={alreadyAttended}
      />
                <Container fluid className="pitable_container mt-2 p-2">
                <Row className='searchbar mt-0'>
                  <Col className='searchFiled gap-2 gap-md-3'>
                    <input type="text" value={searchText} placeholder='Search with Subject ID or Phone No' onChange={handleSearchData} style={{width:"400px"}}/>
                    <div className=" ">
                  
                    </div>

                  </Col>
                </Row>
  
                <div>
                            {loading_flag  ? (
                                <div className=''>
                                <img
                                  className="atrium_loader_pirej"
                                  src="/images/circle-effect-loading.gif"
                                  alt="Loader"
                         
                                />
                              </div>
                            ) : (
                            <div className="table-scroll-container ">
                              {rejectedEventsList?.length > 0 || filteredData?.length > 0  ?
                                <Table bordered size="sm" className="pitable rejeventtblmbl">
                                  <thead className='sticky_table_header'>
                                    <tr>
                                      <th> S.No</th>
                                      <th className='sticky-header'>
                                      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                                        <span style={spanStyles}>Subject Id</span>
                                                        <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{float:"right"}}>
                                                                <g id="icon_sort">
                                                                    <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc?"black":"#E1E5E7"} onClick={handleDescending} className='svg-cursor'/>
                                                                    <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc?"black":"#E1E5E7"} onClick={handleAscending} className='svg-cursor'/>
                                                                </g>
                                                            </svg>
                                                            </div>
                                                        </th>
                                      <th style={{minWidth:"70px"}}>
                                        Subject Name
                                      </th>
                                      <th style={{ minWidth: "70px" }}>
                                        Phone No
                                      </th>
                                      <th style={{ minWidth: "70px" }}>
                                        Gender
                                      </th>
                                      <th>
                                        Date of Report
                                      </th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                   
                                  <tbody className="tableBodyScroll">
                                    {filteredData?.map((i, index) => {
                                        const numbersArray = i.subject_code.split('/').filter(item => item.trim() !== '');
                                        let lastNumber=[]
                                        if (numbersArray.length > 0) {
                                            lastNumber = numbersArray[numbersArray.length - 1];
                                                            }
                                      const formatedDate=formatDate(i.lastUpdated)
                                      return (
                                        
                                        <tr key={i.index} className='text_left_table'>
                                                                                  
                                           <td className='text_right_sno'> {index + 1} </td>
                                          <td >{lastNumber ? lastNumber :"-"}</td>
                                          <td>{i.subject_code? i.subject_code :"-"}</td>
                                          <td>{i.first_name +  " "+i.last_name}</td>
                                          <td>{i.phone_number ? i.phone_number :"-"}</td>
                                          <td onClick={() => handleRespond(i)}>
                                          {i.sex ? i.sex:"-"}
                                          <img className='tblrightarrowmbl' src="./images/icons/down_arrow.svg" alt="" />
                                          </td>
                                          <td className='text-center'>{formatedDate ? formatedDate:"-" }</td>
                                         
                                          <td className="viewbtnstyl">
                                            <button className="gray_btn px-3" onClick={() => handleRespond(i)}>
                                                Respond
                                            </button>
                                          </td> 
                                          
                                        
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                  
                                </Table>
                                : rejectedEventsList === null && localStorage.study_id ? <div className=''>
                                <img
                                    className="atrium_loader"
                                    src="/images/circle-effect-loading.gif"
                                    alt="Loader"
            
                                />
                              </div> :
                                <div className="table-scroll-container">
                                <Table bordered size="sm" className="pitable rejeventtblmbl">
                                <thead>
                                  <tr>
                                    <th> S.No</th>
                                    <th style={{ minWidth: "145px" }}>
                                    Subject Name    
                                    </th>
                                    <th style={{ minWidth: "125px" }}>
                                      Phone No
                                    </th>
                                    <th style={{ minWidth: "70px" }}>
                                        Gender
                                      </th>
                                    <th>
                                    Date of Report
                                    </th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                <tr>
                                {/* for mobile */}
                                <td colSpan="7" className="bg-white border py-4 text-center " > 
                                No records found
                                </td>
                                 {/* for mobile */}
                                  <td colSpan="7" className="bg-white border py-4 text-center " >
                                    No records found
                                  </td>
                                </tr>
                              </tbody>
                              </Table>
                            
                              </div>
                              
                              }
                            </div>
                            )}
                        </div>
              </Container>
              {loading && <Loader />}
            </div>
        </div>
  )
}

export default RejectedSubjects